import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import FormDropdown from "./FormDropdown";
import DropdownView from "../views/ReportPresensi/DropdownViewB";
import DatePicker from "react-datepicker/es";
import moment from "moment";
import axios from "../axios";
import Alert from "react-s-alert";
import Dropzone from "react-dropzone";

class IzinModalGuru extends Component {

    constructor(props) {
        super(props);

        this.state = {
            kelas_id:"",
            guru_id:"",
            keterangan:"",
            status:"",
            presensi_id:"",
            status_izin:"",
            isButtonLoading: false,
            isLoading: false,
            izin_file:''
        };


        this.handleChange = this.handleChange.bind(this);
        this.handleToggle = this.handleToggle.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        if (value == 'not_taken') {
            this.setState({
                status_izin:""
            })
        }
        this.setState({
            [name]: value
        })
    }

    handleToggle() {
        this.props.toggleModalGuru()
    }

    handleSubmit() {
        let formData = new FormData();

        const config = {
            headers: { "content-type": "multipart/form-data" }
        };
        formData.append("guru_id", this.props.guruId);
        formData.append("keterangan", this.state.keterangan);
        formData.append("status", this.state.status);
        formData.append("izin_file", this.state.izin_file);
        formData.append("status_izin", this.state.status_izin);
        formData.append("event_mulai", this.props.tgl);
        formData.append("type", this.props.type);

        const url = "tambah_presensi_guru";

        this.setState({ isButtonLoading: true });

        axios
            .post(url, formData, config)
            .then(response => {
                const result = response.data;
                if (result.success) {
                    Alert.success(result.message);
                    window.location.reload();
                } else {
                    if (Array.isArray(result.message)) {
                        result.message.map(item => {
                            Alert.error(item);
                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })
            .catch(error => {
                console.log("ERROR", error);
                Alert.error("Gagal terhubung ke server!");
                this.setState({ isButtonLoading: false });
            });
    }

    onChange(evt) {
        this.setState({
            previewImg: null,
            defaultImg: null,
            imageCrop: null,
            image: evt.target.files[0],
            event_foto: ""
        });
    }

    handleDeleteFile() {
        this.setState({
            izin_file: ""
        })
    }

    onDrop(files) {

        this.setState({
            izin_file: files[0]
        });
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.handleToggle} className="modal-primary">
                <ModalHeader toggle={this.handleToggle}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    <div className="col-sm-12">
                        <div className="card" >
                            <div className="card-block">
                                <div className="form-horizontal animated fadeIn">
                                    <div className="form-group row">

                                        <div className="col-md-12">
                                            <div className="form-group row">
                                                <label className="col-md-4 form-control-label">
                                                    Nama Siswa
                                                </label>
                                                <div className="col-md-8">
                                                    <input className="form-control" disabled="disabled" value={this.props.nama +' '+this.props.guruId} />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-4 form-control-label">
                                                    Type Absen
                                                </label>
                                                <div className="col-md-8">
                                                    <input className="form-control" disabled="disabled" value={this.props.type == 'in' ? 'Masuk' : 'Pulang'} />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-4 form-control-label">
                                                    Tanggal
                                                </label>
                                                <div className="col-md-8">
                                                    <input className="form-control" disabled="disabled" value={this.props.tgl} />
                                                </div>
                                            </div>
                                            <div className="">
                                                <DropdownView
                                                    handleChange={this.handleChange}
                                                    stateName="status"
                                                    label="Status"
                                                    items={[
                                                        { key: "absent", value: "Izin" },
                                                        { key: "not_taken", value: "Alpha" },
                                                        { key: "present", value: "Hadir" },
                                                        { key: "late", value: "Telat" }
                                                    ]}
                                                    value={this.state.status}
                                                />

                                                {this.state.status === ''?(
                                                    ""
                                                ):(
                                                    this.state.status === 'absent'?(
                                                        <DropdownView
                                                            handleChange={this.handleChange}
                                                            stateName="status_izin"
                                                            label="Status Izin"
                                                            items={[
                                                                { key: "1/2hari", value: "1/2 Hari" },
                                                                { key: "acara_keluarga", value: "Acara Keluarga" },
                                                                { key: "sakit", value: "Sakit" },
                                                                { key: "acara_sekolah", value: "Acara Sekolah" },
                                                                { key: "lain_lain", value: "Lain-Lain" }
                                                            ]}
                                                            value={this.state.status_izin}
                                                        />
                                                    ) : ""
                                                )}
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-4 form-control-label">
                                                    Keterangan
                                                </label>
                                                <div className="col-md-8">
												<textarea
                                                    label="keterangan"
                                                    name="keterangan"
                                                    className="form-control"
                                                    placeholder="Ketik keterangan disini ..."
                                                    onChange={this.handleChange}
                                                    value={this.state.keterangan}
                                                    style={{ marginBottom: 10 }}
                                                />

                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File Bukti</label>
                                                <div className="col-md-12">

                                                    <Dropzone
                                                        onDrop={this.onDrop.bind(this)}
                                                        multiple={false}
                                                        style={{
                                                            width: "100%",
                                                            height: "auto",
                                                            border: "2px dashed #e9e9e9",
                                                            padding: "20px 30px",
                                                            color: "#888",
                                                            cursor: "pointer",
                                                            textAlign: "center",
                                                            marginBottom: "15px"
                                                        }}
                                                    >
                                                        Klik disini untuk mengupload file surat izin atau bukti izin yang lain
                                                    </Dropzone>

                                                    {
                                                        this.state.izin_file !== "" &&
                                                        <span>
                                                            {this.state.izin_file.name} {" "}
                                                            <button
                                                                title="Hapus"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => this.handleDeleteFile()}
                                                                type="button"
                                                            >
                                                                <i className="fa fa-remove"></i>
                                                            </button>
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                            <label className="col-md-12 form-control-label">
                                                <strong>*Format yang di dukung : .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg</strong><br/>
                                                <strong>*Maksimal ukuran file 2MB</strong><br/>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-md btn-primary"
                        disabled={this.state.isButtonLoading && "disabled"}
                        onClick={this.handleSubmit}
                    >
                        {this.state.isButtonLoading ? "Loading" : "Simpan"}
                    </button>{" "}
                    <button
                        type="button"
                        className="btn btn-md btn-danger"
                        disabled={this.state.isButtonLoading && "disabled"}
                        onClick={this.handleToggle}
                    >
                        Batal
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

IzinModalGuru.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    guruId: PropTypes.string.isRequired,
    nama: PropTypes.string.isRequired,
    tgl: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModalGuru: PropTypes.func.isRequired,
}

export default IzinModalGuru


// WEBPACK FOOTER //
// ./src/components/IzinModalGuru.js